import { useMemo } from 'react';
import type {
  LabTestCollectionMethodT,
  LabTestSampleTypeT,
  SearchLabTestsRequestT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { useSearchLabTestsQuery } from '@/entities/labs';

export interface LabTestSearchInput {
  name: string;
  method?: LabTestCollectionMethodT | null;
  sampleType?: LabTestSampleTypeT | null;
}

export function useLabTestSearch(input: LabTestSearchInput | undefined) {
  const filters = useMemo((): SearchLabTestsRequestT => {
    const name = input?.name?.trim() ?? '';

    return {
      ...(name !== '' ? { name } : {}),
      ...(input?.method ? { method: input.method } : {}),
      ...(input?.sampleType ? { sampleType: input.sampleType } : {}),
    };
  }, [input]);

  return useSearchLabTestsQuery(filters);
}
